import React from 'react';
import { StyledHeader } from './styles';
import { Link } from '../../utils/theme';
import { MLHLogo } from './styles';
import { EXTERNAL_LINKS } from '../../utils/links';

const Header: React.FC = () => {
    const handleScroll = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href')?.slice(1); // Remove '#' from href
        const targetElement = targetId ? document.getElementById(targetId) : null;
    
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth'
          });
        }
    };

    return (
        <StyledHeader>
            <Link href={EXTERNAL_LINKS['DH_MAIN']} target="_blank" rel="noopener noreferrer">DubHacks</Link>
            <Link href="#about" onClick={handleScroll}>Theme</Link>
            <Link href="#schedule" onClick={handleScroll}>Schedule</Link>
            <Link href="#faq" onClick={handleScroll}>FAQs</Link>
            <MLHLogo id="mlh-trust-badge" href="https://mlh.io/na?utm_source=na-hackathon&utm_medium=TrustBadge&utm_campaign=2025-season&utm_content=gray" target="_blank">
              <img
                src="https://s3.amazonaws.com/logged-assets/trust-badge/2025/mlh-trust-badge-2025-gray.svg"
                alt="Major League Hacking 2025 Hackathon Season" 
                width="100%"
              />
            </MLHLogo>
        </StyledHeader>
  );
}

export default Header;
